import HarveyBall from './HarveyBall';

/**
 * SpecRow — A single specification row in the PDP spec table.
 *
 * @param {string}  label        — display label
 * @param {*}       value        — string, number, or null
 * @param {string}  [unit]       — optional unit suffix (e.g. "mm", "kg")
 * @param {boolean} [isHarveyBall=false] — render a HarveyBall instead of text
 * @param {string}  [renderAs]   — special render mode: "externalLink" turns
 *                                 a URL string into "View spec sheet ↗".
 * @param {boolean} [alternate=false]    — use alternate row background
 */
export default function SpecRow({
  label,
  value,
  unit,
  isHarveyBall = false,
  renderAs,
  alternate = false,
}) {
  // Skip rows with no value
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const renderValue = () => {
    if (isHarveyBall) {
      return <HarveyBall value={Number(value)} />;
    }
    if (renderAs === 'externalLink' && typeof value === 'string' && /^https?:\/\//i.test(value)) {
      return (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="text-electric-blue font-sandvik-text hover:underline inline-flex items-center gap-1"
        >
          View spec sheet
          <span aria-hidden="true">↗</span>
        </a>
      );
    }
    return (
      <span className="text-carbon-black font-sandvik-text">
        {value}{unit ? ` ${unit}` : ''}
      </span>
    );
  };

  return (
    <div
      className={`grid grid-cols-2 py-3 px-4 ${
        alternate ? 'bg-n1' : 'bg-white'
      }`}
    >
      <span className="text-n7 font-sandvik-text">{label}</span>
      {renderValue()}
    </div>
  );
}
